import axiosInstance from '../axiosConfig';

export default {
  async createOrder(payload) {
    const response = await axiosInstance.post('EcomCrearPedido', payload);
    return response.data;
  },
  async getOrderInfo(payload) {
    const response = await axiosInstance.post('EcomPedidoExitoso', payload);
    return response.data;
  },
};
